import { render, staticRenderFns } from "./OwnerPaxFormItem.vue?vue&type=template&id=0fca3047&scoped=true&"
import script from "./OwnerPaxFormItem.vue?vue&type=script&lang=js&"
export * from "./OwnerPaxFormItem.vue?vue&type=script&lang=js&"
import style0 from "./OwnerPaxFormItem.vue?vue&type=style&index=0&id=0fca3047&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca3047",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListItemContent } from 'vuetify/lib'
import { VListItemSubtitle } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VAvatar,VBtn,VChip,VFlex,VIcon,VImg,VLayout,VListItemContent,VListItemSubtitle,VListItemTitle,VSpacer,VSwitch,VTextField,VTextarea})
